<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2022-05-26 16:22:11
 * @LastEditors: mrh
 * @LastEditTime: 2022-05-30 14:20:54
-->
<template>
  <div class="tables">
    <div>
      <h6>昵称/用户名</h6>
      <p><span>使用目的</span> <span>用于完善网络身份标识</span></p>
      <p><span>使用场景</span> <span>用于个人主页的个性化信息展示</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.name ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.name || "-" }}</span>
      </p>
    </div>
    <div>
      <h6>手机号码</h6>
      <p><span>使用目的</span> <span>用于完善网络身份标识</span></p>
      <p><span>使用场景</span> <span>用户注册、登录及实名认证</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.phone ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.phone || "-" }}</span>
      </p>
    </div>
    <div>
      <h6>头像</h6>
      <p><span>使用目的</span> <span>用于展示头像信息</span></p>
      <p><span>使用场景</span> <span>用于个人主页的个性化信息展示</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.headpic ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span class="headpic">{{ user.headpic || "-" }}</span>
      </p>
    </div>
    <!-- <div>
      <h6>真实姓名</h6>
      <p><span>使用目的</span> <span>用于备课的实名认证</span></p>
      <p><span>使用场景</span> <span>进行教师认证时</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.realName ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.realName || "-" }}</span>
      </p>
    </div>
    <div>
      <h6>教师证编号</h6>
      <p><span>使用目的</span> <span>用于备课的实名认证</span></p>
      <p><span>使用场景</span> <span>进行教师认证时</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.number ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ "-" }}</span>
      </p>
    </div>
    <div>
      <h6>教师证图片</h6>
      <p><span>使用目的</span> <span>用于备课的实名认证</span></p>
      <p><span>使用场景</span> <span>进行教师认证时</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.image ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ "-" }}</span>
      </p>
    </div> -->
    <div>
      <h6>第三方账号</h6>
      <p><span>使用目的</span> <span>用于使用第三方账号授权登录</span></p>
      <p><span>使用场景</span> <span>用户使用第三方账号登录</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.name ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.name || "-" }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { getPersonInfo } from "@/api/join";
import Vue from "vue";
import axios from "axios";
export default {
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    const origin = window.location.origin;
    let baseURLs = window.location.origin; // 请求接口前缀
    // Vue.prototype.imgPrex = "http://img.yamyamyam.com"; // 图片服务器前缀
    if (origin.indexOf("192.168.1.58") != -1) {
      // 悦买测试环境
      // 58环境下使用调试工具
      // Vue.use(vConsole);
      baseURLs = `${origin}/app`;
    } else if (window.location.host.indexOf("192.168.1.59:7210") != -1) {
      // 店长测试环境
      // 60环境下使用调试工具
      // let vConsole = new Vconsole();
      // Vue.use(vConsole);
      baseURLs = "http://192.168.1.59:7210/app";
    } else if (
      origin.indexOf("localhost") != -1 ||
      origin.indexOf("127.0.0.1") != -1 ||
      origin.indexOf("192.168") != -1
    ) {
      // 本地环境
      axios.defaults.baseURL = "/dev/";
    }
    // console.log(axios.defaults.baseURL)
    axios
    .post(baseURLs+"/buyer/2_1/member/getPersonInfo", {})
    .then(res => {
        console.log(res);
      if (res.data.appStatus.errorCode == 0) {
        this.user = res.data.content;
      }
    });
  },
  methods: {
    replaceStr(str, index, char) {
      const strAry = str.split("");
      strAry[index] = char;
      return strAry.join("");
    },
  },
};
</script>

<style lang="scss" scoped>
.tables {
  margin: 10px;
  padding-bottom: 30px;
  > div {
    margin-top: 20px;
    background: #d9d9d9;
    h6 {
      background: #fff;
    }
    p {
      font-size: 14px;
      display: flex;
      line-height: 30px;
      span:first-child {
        background: #d9d9d9;
        width: 100px;
        text-align: center;
      }
      span:last-child {
        width: 100%;
        display: block;
        background: #fff;
        border: 1px solid #d9d9d9;
        text-align: center;
      }
      .headpic {
        word-break: break-all;
        overflow-wrap: break-word;
      }
    }
  }
}
</style>
